// extracted by mini-css-extract-plugin
export default {"galleryIcon":"xoEaCz"};